import { render, staticRenderFns } from "./auditDialog.vue?vue&type=template&id=050a0fb2&scoped=true"
import script from "./auditDialog.vue?vue&type=script&lang=js"
export * from "./auditDialog.vue?vue&type=script&lang=js"
import style0 from "./auditDialog.vue?vue&type=style&index=0&id=050a0fb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050a0fb2",
  null
  
)

export default component.exports